import { render, staticRenderFns } from "./PayPeriodToggle.vue?vue&type=template&id=52524b93&"
import script from "./PayPeriodToggle.vue?vue&type=script&lang=js&"
export * from "./PayPeriodToggle.vue?vue&type=script&lang=js&"
import style0 from "./PayPeriodToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports